export const CHANNEL_LIST = "CHANNEL_LIST";
export const CURRENT_CHANNEL = "CURRENT_CHANNEL";
export const CHANNEL_HASH = "CHANNEL_HASH";
export const SEARCH_HASH = "SEARCH_HASH";
export const CHANNEL_COUNT = "CHANNEL_COUNT";